<template>
  <section class="super-touch-oversea">
    <div v-textMotion="300" class="super-touch-oversea-text-intro">
      <p class="title">{{ $t('super-touch-title') }}</p>
      <p class="description">{{ $t('super-touch-description') }}</p>
    </div>
    <div class="super-touch-oversea-sticky">
      <div
        class="super-touch-oversea-phone-container"
        :class="{ leave: phoneIsLeave, active: phoneIsActive }"
        :style="{ transform: phoneModelY }"
      >
        <div v-show="!screenIsActive" class="video">
          <lazy-component style="height: 100%" @show="showVideo">
            <video
              id="super-touch-video"
              muted
              :src="require('../../assets/fluent/super-touch/super-touch-video-en.mp4')"
            />
          </lazy-component>
        </div>
        <img v-lazy="require('../../assets/fluent/super-touch/screen-bg.png')" class="screen-bg" alt="ColorOS 11" />
        <img
          v-lazy="require('../../assets/fluent/super-touch/screen1.png')"
          :class="[{ active: screenIsActive }]"
          class="screen1"
          alt="ColorOS 11"
        />
        <img
          v-lazy="require('../../assets/fluent/super-touch/screen2.png')"
          :class="[{ active: screenIsActive }]"
          class="screen2"
          alt="ColorOS 11"
        />
        <div class="pag" :class="[{ active: screenIsActive }]">
          <div class="ball" />
          <div class="item" />
          <div class="item" />
          <div class="item" />
        </div>
        <img v-lazy="require('../../assets/fluent/super-touch/phone-model.png')" class="phone" alt="ColorOS 11" />
        <img v-lazy="require('../../assets/fluent/super-touch/bg.jpg')" class="phone-bg" alt="ColorOS 11" />
      </div>
      <div
        v-show="phoneIsLeave"
        class="ai-preloading-icons"
        :style="{ width: scale * phoneWidth + 'px', transform: `translate3d(-50%,${iconsY}%,0)` }"
        :class="iconsIsActive ? 'ai-preloading-icons__active' : ''"
      >
        <div class="line line1">
          <figure class="ai-preloading-icon-container">
            <!-- <transition name="fade-in"> -->
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon1b.png')" />
            <!-- </transition> -->
            <transition name="fade-out">
              <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon1.png')" />
            </transition>
          </figure>
          <figure class="ai-preloading-icon-container">
            <img v-lazy="require(`../../assets/fluent/super-touch/icon2.png`)" alt="ColorOS 11" />
          </figure>
          <figure class="ai-preloading-icon-container">
            <!-- <transition name="fade-in"> -->
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon3b.png')" />
            <!-- </transition> -->
            <transition name="fade-out">
              <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon3.png')" />
            </transition>
          </figure>
          <figure class="ai-preloading-icon-container">
            <img v-lazy="require(`../../assets/fluent/super-touch/icon4.png`)" alt="ColorOS 11" />
          </figure>
        </div>
        <div class="line line2">
          <figure class="ai-preloading-icon-container">
            <!-- <transition name="fade-in"> -->
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon5b.png')" />
            <!-- </transition> -->
            <transition name="fade-out">
              <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon5.png')" />
            </transition>
          </figure>
          <figure class="ai-preloading-icon-container">
            <img v-lazy="require(`../../assets/fluent/super-touch/icon6.png`)" alt="ColorOS 11" />
          </figure>
          <figure class="ai-preloading-icon-container">
            <img v-lazy="require(`../../assets/fluent/super-touch/icon7.png`)" alt="ColorOS 11" />
          </figure>
          <figure class="ai-preloading-icon-container">
            <img v-lazy="require(`../../assets/fluent/super-touch/icon8.png`)" alt="ColorOS 11" />
          </figure>
        </div>
        <div class="line line3">
          <figure class="ai-preloading-icon-container">
            <!-- <transition name="fade-in"> -->
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon9b.png')" />
            <!-- </transition> -->
            <transition name="fade-out">
              <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon9.png')" />
            </transition>
          </figure>
          <figure class="ai-preloading-icon-container">
            <transition name="fade-out">
              <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon10.png')" />
            </transition>
            <transition name="fade-in">
              <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon10b.png')" />
            </transition>
          </figure>
          <figure class="ai-preloading-icon-container">
            <!-- <transition name="fade-in"> -->
            <img v-show="iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon11b.png')" />
            <!-- </transition> -->
            <transition name="fade-out">
              <img v-show="!iconsIsActive" v-lazy="require('../../assets/fluent/super-touch/icon11.png')" />
            </transition>
          </figure>
          <figure class="ai-preloading-icon-container">
            <img v-lazy="require(`../../assets/fluent/super-touch/icon12.png`)" alt="ColorOS 11" />
          </figure>
        </div>

        <img v-lazy="require(`../../assets/fluent/super-touch/link-h.png`)" class="ai-link-h ai-link-h-1" />
        <img v-lazy="require(`../../assets/fluent/super-touch/link-h.png`)" class="ai-link-h ai-link-h-2" />
        <img v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)" class="ai-link-v ai-link-v-1" />
        <img v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)" class="ai-link-v ai-link-v-2" />
        <img v-lazy="require(`../../assets/fluent/super-touch/link-v.png`)" class="ai-link-v ai-link-v-3" />
      </div>
      <div class="ai-preloading-text-intro" :style="text2style">
        <p class="title">{{ $t('ai-preloading-title') }}</p>
        <p class="description">
          {{ $t('ai-preloading-description') }}
          <sup>5</sup>
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';
import Velocity from 'velocity-animate';
const all = 2400;
const point1 = 480 / all;
const point2 = 960 / all;
const point3 = 1245 / all;
const point4 = 1440 / all;
const point5 = 1920 / all;

export default {
  mixins: [UpdateAnimationMixin],
  inject: ['lang'],
  data() {
    return {
      // 总滚动距离 3840 - 6240 = 2400
      //   视频换图片 0/3840
      //   手机固定 0 - 480/3840 - 4320
      //   手机切屏幕 480
      //   手机位移动画 480 - 960/4320 - 4800
      //   手机隐藏,图标显示 960
      //   图标上移 960 - 1440/4800 - 5280
      //   文字上移 1245 - 1440/5095 - 5280
      //   图标变大 1440/5280
      //   图标连接出现,部分图标变暗 1920/5760
      duration: 2400,
      progress: 0,
      topProgress: 0,
      progressLinear: 0,
      phoneWidth: 0,
      scale: 0.78,
      debenceFlag: false,
      playing: false,
      screenIsActive: false,
      iconsIsActive: false
    };
  },
  computed: {
    phoneModelY() {
      let progress = this.progressLinear;
      if (progress > point2) progress = point2;
      // 小于 0.313 时保持不动
      if (progress < point1) return '';
      // 从 0.313 到 0.633, 从 -22.5 到 +4.3
      return 'translateY(' + (-22.5 + (26.8 * (progress - point1)) / (point2 - point1)) + '%)';
    },
    phoneIsLeave() {
      return this.progressLinear > point2;
    },
    phoneIsActive() {
      return this.topProgress > 0;
    },
    iconsY() {
      var point2Offset = point2 + 0.05;
      let progress = this.progressLinear;
      if (progress < point2Offset) return '0';
      if (progress > point4) progress = point4;
      return (-54 * (progress - point2Offset)) / (point4 - point2Offset);
    },
    text2style() {
      let progress = this.progressLinear;
      if (progress < point3) return '';
      if (progress > point4) progress = point4;
      const all = point4 - point3;
      const now = progress - point3;
      const o = 'opacity:' + now / all + ';';
      const t = 'transform:translateY(' + (-300 * now) / all + '%);';
      return o + t;
    }
  },
  mounted() {
    const handleResize = () => {
      // 434 / 952
      const phoneHeight = Math.min(window.innerHeight * 0.99, 952);
      this.phoneWidth = (434 / 952) * phoneHeight;
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    new ScrollMagic.Scene({
      duration: 2400,
      triggerElement: '.super-touch-oversea-sticky',
      triggerHook: 0
    })
      .setPin('.super-touch-oversea-sticky')
      .addTo(Controller)
      .on('progress', e => {
        this.progressLinear = e.progress;
        this.updateBezier('progress', e.progress, 500);
        this.dealProgress(e.progress);
      });

    new ScrollMagic.Scene({
      duration: 0.8 * window.innerHeight,
      triggerElement: '.super-touch-oversea-text-intro',
      triggerHook: 0.5
    })
      .addTo(Controller)
      .on('progress', e => {
        const p = e.progress;
        this.topProgress = p;
        // 视屏播放
        if (!this.video) {
          return;
        } else if (p > 0.6 && !this.playing) {
          this.playing = true;
          this.video.currentTime = 0;
          this.video.play();
        } else if (p < 0.2 && this.videoEnded) {
          this.playing = false;
        }
      });
  },
  methods: {
    dealProgress(p) {
      // 切屏动画
      if (p + 0.1 > point1 && !this.screenIsActive && !this.fastGoEnd) {
        var v = this.video;
        if (v) {
          var videoTime = v.duration;
          v.currentTime = videoTime;
          v.pause();
          this.fastGoEnd = true;
        }
      }
      if (p + 0.05 > point1 && !this.screenIsActive) {
        this.screenIsActive = true;
      }
      if (p + 0.05 < point1) {
        this.screenIsActive = false;
      }
      // 图标规则
      if (p < point4) {
        this.scale = 0.784;
        this.debenceFlag = false;
      }
      if (p > point4 && !this.debenceFlag) {
        this.debenceFlag = true;
        const dom = document.getElementsByClassName('ai-preloading-icons')[0];
        Velocity(dom, { width: [1.35 * this.phoneWidth, 0.784 * this.phoneWidth] }, 800, [500, 15]);
        setTimeout(() => {
          this.scale = 1.35;
        }, 900);
      }
      // 图标激活规则
      if (p + 0.02 > point5 && !this.iconsIsActive) {
        this.iconsIsActive = true;
      }
      if (p + 0.02 < point5) {
        this.iconsIsActive = false;
      }
    },
    // lazy-component 出现后注册内容
    showVideo() {
      if (!this.video) {
        setTimeout(() => {
          this.video = document.getElementById('super-touch-video');
          if (!this.video) {
            this.showVideo();
            return;
          }
          this.video.addEventListener('ended', () => {
            this.videoEnded = true;
            console.log('video end', this.videoEnded);
          });
        }, 30);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.super-touch-oversea {
  position: relative;
  z-index: 1;
  overflow: hidden;
  min-height: 380vh;
}
@media screen and (min-height: 1000px) {
  .super-touch-oversea {
    min-height: 320vh;
  }
}
// super touch
.super-touch-oversea-sticky {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  text-align: center;
}
.super-touch-oversea-phone-container {
  position: relative;
  z-index: 2;
  font-size: 0;
  height: 99%;
  width: 100%;
  max-height: 952px;
  transform: translateY(-22.5%);
  opacity: 0;
  transition: opacity 0.3s linear;

  &.active {
    opacity: 1;
  }
  &.leave {
    opacity: 0;
  }
  .phone {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    height: 100%;
    z-index: 4;
  }
  .phone-bg {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    height: 96.5%;
    top: 1.7%;
  }
  .pag {
    width: 4.15vh;
    height: 0.835vh;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    bottom: 16.85%;
    display: flex;
    justify-content: space-between;
    z-index: 2;
    .item {
      width: 20%;
      border-radius: 50%;
      border-color: #fff;
      border: 1px solid rgba($color: #fff, $alpha: 0.3);
      box-sizing: border-box;
    }
    .ball {
      position: absolute;
      width: 20%;
      border-radius: 50%;
      height: 100%;
      box-sizing: border-box;
      background-color: #fff;
      left: 0;
      transition: 0.3s left cubic-bezier(0.33, 0, 0.67, 1);
    }
    &.active {
      .ball {
        left: 40%;
      }
    }
  }
  .screen-bg {
    position: absolute;
    transform: translate(-50%);
    height: 96.5%;
    top: 1.535%;
    left: 50%;
    z-index: 2;
  }
  .screen1 {
    position: absolute;
    transform: translate(-50%);
    opacity: 1;
    z-index: 2;
    left: 50%;
    top: 1.8%;
    height: 96.5%;
    &.active {
      transition: transform 0.5s cubic-bezier(0.33, 0, 0.67, 1), opacity 0.2s cubic-bezier(0.33, 0, 0.67, 1);
      transform: translateX(-155%);
      opacity: 0;
    }
  }
  .screen2 {
    position: absolute;
    left: 50%;
    height: 68%;
    z-index: 2;
    top: 8.8%;
    transform: translate(60%);
    opacity: 0;
    &.active {
      transition: transform 0.5s cubic-bezier(0.33, 0, 0.67, 1), opacity 0.2s cubic-bezier(0.33, 0, 0.67, 1);
      transform: translate(-50%);
      opacity: 1;
    }
  }
  // 视屏分辨率为 478 / 1057 = 0.4522
  .video {
    position: absolute;
    height: 96.5%;
    left: 50%;
    transform: translate(-50%);
    top: 1.7%;
    z-index: 3;
    border-radius: 10px;
    overflow: hidden;
    video {
      height: 100%;
    }
  }
}
.super-touch-oversea-text-intro {
  padding-top: 102px;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  height: 50vh;
  text-align: center;
  .title {
    font-size: 18px;
    line-height: 26px;
    padding-top: 0px;
    letter-spacing: 0.02em;
    color: #000;
  }
  .description {
    max-width: 586px;
    padding-top: 12px;
    margin: 0 auto;
    line-height: 150%;
    color: rgba($color: #000000, $alpha: 0.55);
  }
}
// 极速启动
.ai-preloading-icons {
  position: absolute;
  overflow: hidden;
  z-index: 99;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  top: 36.8%;
  will-change: transform;
}
.ai-preloading-icons__active {
  .ai-link-h,
  .ai-link-v {
    opacity: 1;
  }
}
.line {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15.79%;
}
.line3 {
  margin-bottom: 0;
}
.ai-preloading-icon-container {
  position: relative;
  display: inline-block;
  width: 17.4%;
  padding-bottom: 17.4%;
  font-size: 0;
  img {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
}
.ai-link-h {
  position: absolute;
  width: 6.133%;
  opacity: 0;
  transition: opacity cubic-bezier(0.33, 0, 0.67, 1) 0.2s;
}
.ai-link-v {
  position: absolute;
  width: 3.41%;
  opacity: 0;
  transition: opacity cubic-bezier(0.33, 0, 0.67, 1) 0.2s;
}
.ai-link-h-1 {
  left: 47.019%;
  top: 47.36%;
}
.ai-link-h-2 {
  left: 74.9%;
  top: 47.36%;
}
.ai-link-v-1 {
  left: 34.47%;
  top: 23.98%;
}
.ai-link-v-2 {
  left: 89.78%;
  top: 23.98%;
}
.ai-link-v-3 {
  left: 89.78%;
  top: 62.8%;
}
.ai-preloading-text-intro {
  position: absolute;
  z-index: 2;
  top: 100vh;
  opacity: 0;
  .title {
    font-size: 18px;
    line-height: 26px;
    color: #000000;
  }
  .description {
    padding-top: 12px;
    line-height: 150%;
    max-width: 576px;
    color: rgba($color: #000, $alpha: 0.55);
  }
}
.fade-in-enter-active {
  transition: opacity 0.6s ease-in-out !important;
}
.fade-in-enter {
  opacity: 0;
}
.fade-in-enter-to {
  opacity: 1;
}

.fade-out-leave-active {
  transition: opacity 0.6s ease-in-out !important;
}
.fade-out-leave-to {
  opacity: 0;
}
.fade-out-leave {
  opacity: 1;
}
</style>
